<modal-form-container
  [title]="saveNumbers ? 'Save the numbers to a tag' : 'Save these numbers as contacts?'"
  [showModal]="showSavePhoneNumbersModal"
  className="md:w-[640px] lg:w-[680px]"
  contentClass="spn-body"
  (closeModalEvent)="closeModal()"
>
  @if (!saveNumbers) {
    <div class="spn">
      <p class="spn__lead">
        {{ formatCount(getTotalPhoneNumbers) }} {{ getTotalPhoneNumbers === 1 ? "number is" : "numbers are" }} not saved as
        contacts yet. Save them to a tag so you can reach them again from your contacts, or
        {{ isScheduled ? "schedule" : "send" }} without saving.
      </p>

      <dl class="spn__counts">
        <div class="spn__count">
          <dt>Typed in</dt>
          <dd>{{ formatCount(messageDetails.phoneNumbers.length || 0) }}</dd>
        </div>
        <div class="spn__count">
          <dt>
            From {{ getCSVFormattedFileData.filesCount }}
            {{ getCSVFormattedFileData.filesCount === 1 ? "file" : "files" }}
          </dt>
          <dd>{{ formatCount(getCSVFormattedFileData.combinedCSVPhoneNumbers.length) }}</dd>
        </div>
      </dl>

      @if (problem) {
        <p class="bk-field__error spn__problem" role="alert">
          <span class="bk-sym" aria-hidden="true">error</span>{{ problem }}
        </p>
      }

      <div class="spn__foot">
        <button
          type="button"
          class="bk-btn bk-btn--ghost"
          [disabled]="broadcastMessageService.isLoading"
          [attr.aria-busy]="broadcastMessageService.isLoading"
          (click)="handleDontSavePhoneNumbers()"
        >
          @if (broadcastMessageService.isLoading) {
            {{ isScheduled ? "Scheduling…" : "Sending…" }}
          } @else {
            {{ isScheduled ? "Schedule without saving" : "Send without saving" }}
          }
        </button>
        <button type="button" class="bk-btn bk-btn--primary" (click)="setSaveNumbers(true)">
          Save to a tag
          <span class="bk-sym spn__trail" aria-hidden="true">arrow_forward</span>
        </button>
      </div>
    </div>
  } @else {
    <save-phone-number-to-tag
      (goToPrevious)="setSaveNumbers(false)"
      (selectedTagsChange)="updateSelectedTags($event)"
      [newTagForm]="newTagForm"
      [submitted]="submitted"
      [loading]="broadcastMessageService.isLoading"
      [problem]="problem"
      [scheduled]="isScheduled"
      (submitEvent)="handleFinalSubmission()"
      (updateSaveToExistingTagsEvents)="updateSaveToExistingTags($event)"
    />
  }
</modal-form-container>
